import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { UseAdvContract } from "./UseAdvContract";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { removeComma, toMoney } from "../../util/Utils";
import AdvCustomerAutoComplete from "../adv-customers/AdvCustomerAutoComplete";

export default function AddContract(props) {
  const { toSolar } = require("jdate-convert");
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [advContract, setAdvContract] = useState();
  const { validate, addAdvContract } = UseAdvContract();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

  const [state, setState] = useState({
    factorDate: undefined,
    customerID: undefined,
    cost: undefined,
    vat: undefined,
    totalCost: undefined,
    isSettle: false,
    discount: undefined,
    active: false,
    isOfficial: false,
    description: undefined,
  });

  const [errorState, setErrorState] = useState({
    customerID: false,
    totalCost: false,
    factorDate: false,
  });

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, factorDate: newValueStart });
  }, [valueStart]);

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertismentcontract" },
          {
            name: "قرارداد جدید",
            url: "/advertismentcontract/addAdvertismentContract",
          },
        ],
      }}
    >
      {!advContract ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueStart}
              value={state && state.factorDate ? toSolar(state.factorDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ قرارداد"
                  error={errorState.factorDate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <AdvCustomerAutoComplete
              selectedCustomerID={state.customerID}
              errorState={errorState.customerID}
              state={state}
              setState={setState}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.cost ? toMoney(state.cost) : ""}
              label="مجموع"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                // let vatCost =
                //   (removeComma(evt.target.value) * window.ENV.taxValue) / 100;
                setState({
                  ...state,
                  cost: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.vat ? toMoney(state.vat) : ""}
              label="مالیات بر ارزش افزوده"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  vat: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.discount ? toMoney(state.discount) : ""}
              label="تخفیف"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  discount: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.totalCost ? toMoney(state.totalCost) : ""}
              label="مبلغ قابل پرداخت"
              error={errorState.totalCost}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  totalCost: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box gridColumn="span 12">
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              multiline
              rows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.isOfficial ? state.isOfficial : false}
              onChange={(evt) => {
                setState({ ...state, isOfficial: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فاکتور به صورت رسمی ارسال شود"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.active ? state.active : false}
              onChange={(evt) => {
                setState({ ...state, active: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addAdvContract(state, () => {
                    navigate("/advertismentcontract", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertismentcontract", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
